import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import "./emailWindow.css";
import { htmlEmailSend } from "../services/emailService";
import {
	newColumnRecipientOfFactory,
	newColumnRecipientOfJD,
	CC_newColumnRecipientOfFactory,
	CC_newColumnRecipientOfJD,
} from "../services/emailService";
import {
	pickupPlanMailBodyForFactory,
	pickupPlanMailBodyForJD,
	pickupPlanMailBodyForTransporter,
} from "./planUploadMail";
import { filter, includes } from "lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
import { getAllModuleShipmentList } from "../services/dataService";
import { EMAIL_WINDOW_COLUMN } from "../components/columns/tractorBookingColumns";
import { TableCheckbox } from "../components/common/tables/TableCheckbox";
import { allModuleDataCreatorForStore } from "../utils/dataFilter";
import { dispatcher } from "../store/storeHelpers";
import * as actionTypes from "../store/ActionTypes";
import store from "../store/Store";
import DailyPlanEmailStatus from "./dailyPlanEmailStatus";
import {
	emailStatusTractor,
	emailStatusAggregate,
	emailStatus5M,
} from "../services/emailService";
import MainTablePaginationAdv from "../components/common/tables/MainTablePaginationAdv";
import noDataAvailable from "../assets/img/noDataAvailable.png";
import Counters from "../components/common/Counters";
import DailyEmailHeaderTemplate from "./DailyEmailHeaderTemplate";
import { PulseLoader } from "react-spinners";

function DailyPlanEmailWindow({ type }) {
	const [factoryCheckboxCheck, setFactoryCheckboxCheck] = useState(false);
	const [JDCheckboxCheck, setJDCheckboxCheck] = useState(false);
	const [transporterCheckboxCheck, setTransporterCheckboxCheck] =
		useState(false);
	const [ToRecipientId, setToRecipientId] = useState("");
	const [CCRecipientId, setCCRecipientId] = useState("");
	const [emailBtn, setEmailBtn] = useState("Send Email");
	const [emailData, setEmailData] = useState([]);
	// const [columns] = useState([EMAIL_WINDOW_COLUMN])
	const [planDate, setPlanDate] = useState(moment().format("YYYY-MM-DD"));
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [totalCount, setTotalCount] = useState(0);
	const [showDailyMailHeaderTemplate, setShowDailyMailHeaderTemplate] =
		useState(false);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setTableData(Object.values(store.getState().daily_plan_email_data));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Daily Plan Email", View: 1 }).length > 0
		) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Daily Plan Email", View: 1 })
			);
		}
	}, [userData]);

	var allowToSend = filter(filteredUserAccessData, { SendEmail: 1 }).length > 0;

	useEffect(() => {
		async function getAllShipmentList() {
			if (type === "DailyEmailWindow") {
				try {
					setLoading(true);
					setNoDataState(false);
					const response = await getAllModuleShipmentList(planDate);
					setTotalCount(response.data.Shipmentmaillist2[0]["Total"])
					dispatcher(
						actionTypes.DAILY_PLAN_EMAIL_DATA,
						allModuleDataCreatorForStore(response.data.Shipmentmaillist1)
					);
					setLoading(false);
				} catch (error) {
					setTableData([]);
					setTotalCount(0)
					if (error.response.data.StatusCode === 404) {
						setNoDataState(true);
					}
					setLoading(false);
				}
			}
		}
		getAllShipmentList();
	}, [planDate, type]);

	function showCheckbox(row) {
		if (row.original.Container_Count !== "") {
			return true;
		} else return false;
	}

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		prepareRow,
		selectedFlatRows,
		setGlobalFilter,
	} = useTable(
		{
			columns: EMAIL_WINDOW_COLUMN,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect,
		(hooks) => {
			hooks.visibleColumns.push((columns) => [
				{
					id: "selection",
					Header: ({ getToggleAllPageRowsSelectedProps }) => (
						<div>
							<TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
						</div>
					),
					Cell: ({ row }) =>
						showCheckbox(row) && (
							<div>
								<TableCheckbox {...row.getToggleRowSelectedProps()} />
							</div>
						),
				},
				...columns,
			]);
		}
	);
	const { pageIndex, pageSize, globalFilter } = state;

	useEffect(() => {
		var planningId = [];
		for (let i = 0; i < selectedFlatRows.length; i++) {
			if (selectedFlatRows[i].originalSubRows.length === 0) {
				if (selectedFlatRows[i].original.Container_Count !== "") {
					if (!includes(planningId, selectedFlatRows[i].original)) {
						planningId.push(selectedFlatRows[i].original);
					}
				}
			}
		}
		setEmailData(planningId);
	}, [selectedFlatRows]);

	useEffect(() => {
		if (emailData.length === 0) {
			setToRecipientId("");
			setCCRecipientId("");
		}
	}, [emailData]);

	async function sendEmailHandler() {
		if(transporterCheckboxCheck === true && !ToRecipientId){
			return toast.error("Transporter Recipient (To) field is mandatory")
		}
		let tractorArray = filter(emailData, { DataOf: "TRACTOR" });
		let aggregateArray = filter(emailData, { DataOf: "AGGREGATE" });
		let fiveMArray = filter(emailData, { DataOf: "5M" });
		let statusTractorIdList = "";
		let statusAggregateIdList = "";
		let status5MIdList = "";
		for (let i = 0; i < tractorArray.length; i++) {
			if (i !== tractorArray.length - 1) {
				statusTractorIdList += tractorArray[i].DailyContainerPlanningID + ",";
			} else {
				statusTractorIdList += tractorArray[i].DailyContainerPlanningID;
			}
		}
		for (let i = 0; i < aggregateArray.length; i++) {
			if (i !== aggregateArray.length - 1) {
				statusAggregateIdList +=
					aggregateArray[i].DailyContainerPlanningID + ",";
			} else {
				statusAggregateIdList += aggregateArray[i].DailyContainerPlanningID;
			}
		}
		for (let i = 0; i < fiveMArray.length; i++) {
			if (i !== fiveMArray.length - 1) {
				status5MIdList += fiveMArray[i].DailyContainerPlanningID + ",";
			} else {
				status5MIdList += fiveMArray[i].DailyContainerPlanningID;
			}
		}
		try {
			setEmailBtn("Sending...");
			setLoading(true);
			if (factoryCheckboxCheck === true) {
				await htmlEmailSend(
					newColumnRecipientOfFactory,
					CC_newColumnRecipientOfFactory,
					"POD, Final Destination, ETA & ETD Details",
					pickupPlanMailBodyForFactory(emailData)
				);
			}
			if (JDCheckboxCheck === true) {
				await htmlEmailSend(
					newColumnRecipientOfJD,
					CC_newColumnRecipientOfJD,
					"Booking status Pick up plan",
					pickupPlanMailBodyForJD(emailData)
				);
			}
			if (transporterCheckboxCheck === true) {
				if (emailData.length !== 0) {
					await htmlEmailSend(
						ToRecipientId,
						CCRecipientId,
						`Pick up plan of transporter/${emailData[0].Transporter}/Stuffing Date - ${emailData[0].JD_Stuffing_Date}`,
						pickupPlanMailBodyForTransporter(emailData)
					);
				}
			}
			if (statusTractorIdList !== "") {
				await emailStatusTractor({
					DailyContainerPlanningTrId: statusTractorIdList,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
				dispatcher(actionTypes.UPDATE_DAILY_PLAN_EMAIL, {
					emailData: emailData,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
			}
			if (statusAggregateIdList !== "") {
				await emailStatusAggregate({
					DailyContainerPlanningAggId: statusAggregateIdList,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
				dispatcher(actionTypes.UPDATE_DAILY_PLAN_EMAIL, {
					emailData: emailData,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
			}
			if (status5MIdList !== "") {
				await emailStatus5M({
					DailyContainerPlanning5MId: status5MIdList,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
				dispatcher(actionTypes.UPDATE_DAILY_PLAN_EMAIL, {
					emailData: emailData,
					isMailSentToFactory: factoryCheckboxCheck,
					isMailSentToJD: JDCheckboxCheck,
					isMailSentToTransporter: transporterCheckboxCheck,
				});
			}
			setFactoryCheckboxCheck(false);
			setJDCheckboxCheck(false);
			setTransporterCheckboxCheck(false);
			setLoading(false);
			setEmailBtn("Send Email");
			setShowDailyMailHeaderTemplate(false);
			toast.success("Email sent successfully");
		} catch (error) {
			setLoading(false);
			setEmailBtn("Send Email");
			toast.error("Something went wrong...please try again.");
		}
	}

	const cellRenderHandler = (cell) => {
		if (cell.column.id === "email_status" && cell.row.subRows.length === 0)
			return "status";
		else return "data";
	};
	// useEffect(() => {
	// 	let totalCounter = [];
	// 	for (let i = 0; i < tableData.length; i++) {
	// 		totalCounter.push(tableData[i]["subRows"].length);
	// 	}
	// 	setTotalCount(sumBy(totalCounter, (datas) => datas));
	// }, [tableData]);

	return (
		<>
			{showDailyMailHeaderTemplate && <DailyEmailHeaderTemplate
				factoryCheckboxCheck={factoryCheckboxCheck}
				JDCheckboxCheck={JDCheckboxCheck}
				transporterCheckboxCheck={transporterCheckboxCheck}
				setToRecipientId={setToRecipientId}
				setCCRecipientId={setCCRecipientId}
				setFactoryCheckboxCheck={setFactoryCheckboxCheck}
				setJDCheckboxCheck={setJDCheckboxCheck}
				setTransporterCheckboxCheck={setTransporterCheckboxCheck}
				ToRecipientId={ToRecipientId}
				CCRecipientId={CCRecipientId}
				emailBtn={emailBtn}
				sendEmailHandler={sendEmailHandler}
				loading={loading}
				allowToSend={allowToSend}
				emailData={emailData}
				show={showDailyMailHeaderTemplate}
				hide={() => setShowDailyMailHeaderTemplate(false)}
			/>}
			<div className="emailWindow__container">
				<div className="dailyEmailWindowCounterDiv">
					<Counters
						counter={{ Total: totalCount }}
						label={["Total"]}
						styleData="df_dailyCounter absolute"
					/>
				</div>
				<div className="dailyEmailWindowHeader">
					<Form.Control
						value={globalFilter || ""}
						onChange={(e) => setGlobalFilter(e.target.value)}
						className="hiden-inp"
						placeholder="search here.."
						style={{
							width: "auto",
							height: "36px",
							position: "relative",
							top: "7px",
							left: "-30px",
						}}
					/>
					<div className="emailWindow__header_dailyPlan">
						<Form.Group>
							<Form.Control
								type="date"
								className="emailWindow_date"
								value={planDate}
								onChange={(e) => setPlanDate(e.target.value)}
							/>
						</Form.Group>
					</div>
					<button
						className="dailyEmailWindowHeader__button"
						onClick={() => setShowDailyMailHeaderTemplate(true)}
						disabled={
							loading === true || !allowToSend || emailData.length === 0
						}
					>
						<i
							className={`bx bxs-right-top-arrow-circle ${
								!allowToSend || emailData.length === 0
									? "dailyEmailWindowHeader__buttonSymbolDisable"
									: "dailyEmailWindowHeader__buttonSymbol"
							}`}
							disabled={
								loading === true || !allowToSend || emailData.length === 0
							}
						></i>
					</button>
				</div>
				{loading && (
					<PulseLoader
						color="#007bff"
						size="20px"
						margin="10px"
						style={{ position: "absolute", top: "50vh", left: "45%" }}
					/>
				)}
				{noDataState && (
					<img
						src={noDataAvailable}
						alt="notAvailableImg"
						className="noDataFoundImg"
						// style={{ marginLeft: "-2%" }}
					/>
				)}
				{/* <hr /> */}
				{!noDataState && (
					<>
						{/* <div className="emailWindow__email_container">
              <div>
                <div className="emailWindow__recipientName">
                  <input
                    type="checkbox"
                    onChange={factoryCheckboxChangeHandler}
                    value={factoryCheckboxCheck}
                  />
                  <label className="emailWindow__columnName_RecipientLabel">
                    Factory
                  </label>
                </div>
                <div className="emailWindow__recipientName">
                  <input
                    type="checkbox"
                    onChange={JDCheckboxChangeHandler}
                    value={JDCheckboxCheck}
                  />
                  <label className="emailWindow__columnName_RecipientLabel">
                    JD
                  </label>
                </div>
                <div className="emailWindow__recipientName">
                  <input
                    type="checkbox"
                    onChange={transporterCheckboxChangeHandler}
                    value={transporterCheckboxCheck}
                  />
                  <label className="emailWindow__columnName_RecipientLabel">
                    Transporter
                  </label>
                </div>
              </div>
              <div
                className="emailWindow__recipientName"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "500px",
                }}
              >
                <label
                  className="emailWindow__columnName_RecipientLabel"
                  style={{ marginLeft: "-240px" }}
                >
                  Transporter Recepient (To) -
                </label>
                <input
                  className="recipientNameClass_dailyEmail"
                  disabled={!transporterCheckboxCheck}
                  onChange={onChangeRecipientTo}
                  name="ToRecipientId"
                  value={ToRecipientId}
                />
              </div>
              <div
                className="emailWindow__recipientName"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "500px",
                }}
              >
                <label
                  className="emailWindow__columnName_RecipientLabel"
                  style={{ marginLeft: "-240px" }}
                >
                  Transporter Recepient (CC) -
                </label>
                <input
                  className="recipientNameClass_dailyEmail"
                  disabled={!transporterCheckboxCheck}
                  onChange={onChangeRecipientCC}
                  name="CCRecipientId"
                  value={CCRecipientId}
                />
              </div>
              <Button
                className="btn-primary sendMailBtn"
                onClick={sendEmailHandler}
                disabled={
                  !(
                    factoryCheckboxCheck ||
                    JDCheckboxCheck ||
                    transporterCheckboxCheck
                  ) ||
                  loading === true ||
                  !allowToSend || emailData.length === 0
                }
              >
                {emailBtn}
              </Button>
            </div> */}
						{/* <hr /> */}
						<div
							className="table_container_for_dailyMail"
							style={{ marginTop: "10px" }}
						>
							<table {...getTableProps()} className="table mtbs">
								<thead>
									{headerGroups.map((headerGroup) => (
										<tr
											{...headerGroup.getHeaderGroupProps()}
											style={{ height: "50px" }}
										>
											{headerGroup.headers.map((column) => (
												<th
													{...column.getHeaderProps(
														column.getSortByToggleProps()
													)}
												>
													{column.render("Header")}
													{column.id !== "selection" && (
														<i
															className={
																column.isSorted
																	? column.isSortedDesc
																		? "fi fi-rr-angle-small-down head-icon"
																		: "fi fi-rr-angle-small-up head-icon"
																	: "fi fi-rr-circle-small head-icon w"
															}
														></i>
													)}
												</th>
											))}
										</tr>
									))}
								</thead>
								<tbody {...getTableBodyProps()}>
									{page.map((row) => {
										prepareRow(row);
										return (
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return (
														<td
															{...cell.getCellProps()}
															className={
																cell.row.subRows.length !== 0
																	? "main-row"
																	: "sub-row"
															}
														>
															<div className="cell-wrap">
																{cellRenderHandler(cell) === "status" && (
																	<DailyPlanEmailStatus cell={cell} />
																)}
																{cellRenderHandler(cell) === "data" &&
																	cell.render("Cell")}
															</div>
														</td>
													);
												})}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
						<MainTablePaginationAdv
							nextPage={nextPage}
							previousPage={previousPage}
							canNextPage={canNextPage}
							pageIndex={pageIndex}
							pageOptions={pageOptions}
							pageSize={pageSize}
							canPreviousPage={canPreviousPage}
							setPageSize={setPageSize}
							gotoPage={gotoPage}
							pageCount={pageCount}
						/>
					</>
				)}
			</div>
		</>
	);
}
export default DailyPlanEmailWindow;
